import React, { useEffect, useState } from 'react';
import './productsStyle.css';
import ReadMoreButton from '../../../../components/buttons/readMoreButton/readMoreButton';
import H2Title from './../../../../components/text/h2Title/h2Title'
import NormalTex from './../../../../components/text/normalText'

export default function Products({title, text, imgSrc}) {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    const handleResize = () => {
        setWindowWidth(window.innerWidth)
    };

    useEffect( () => {
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        }
    }, [])

    if (windowWidth < 769)
        return (
            <section className='products__container'>
                <div className='products__text-container'>
                    <H2Title title={title} />

                    <div className='products__img-container'>
                        <img className='products__img' src={imgSrc} alt="" />
                    </div>

                    <NormalTex text={text}/>

                    <ReadMoreButton url={"/products"}/>
                </div>
                
            </section>
        );

    return (
        <section className='products__container'>
            <div className='products__text-container'>
                <H2Title title={title} />
                <NormalTex text={text}/>
                <ReadMoreButton url={"/products"}/>
            </div>
            <div className='products__img-container'>
                <img className='products__img' src={imgSrc} alt="" />
            </div>
        </section>
    );
}
